import { InstallmentCreate } from './InstallmentCreate'
import { InstallmentEdit } from './InstallmentEdit'
import { InstallmentList } from './InstallmentList'
import { InstallmentShow } from './InstallmentShow'

export { InstallmentCreate, InstallmentEdit, InstallmentList, InstallmentShow }
